<template>
    <div id="asset_defect_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="AssetDefectHeader">Fields To Mapped</span>
                    <router-link class="btn btn-secondary pull-right" v-bind:to="'/import-data'"><i class="fp-back"></i> Back</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content field-to-map">
                        <section class="internal-container border-top-table-fl">
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="mapping_table" class="table table-sm table-bordered">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Fleetpro Label</th>
                                            <th>Spreadsheet Header</th>
                                            <th>Default</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="spreadsheetFieldsArr">
                                            <tr v-for="(data, index2) in spreadsheetFieldsArr" v-bind:key="index2">
                                                <td class='require' v-if="data.type == 'require'">{{ data.name }}</td>
                                                <td v-else>{{ data.name }}</td>
                                                <td v-if="selectedArr[index2]">
                                                    <v-select v-model="selectedArr[index2].text" name="data.value" placeholder="Select"
                                                        label="text"
                                                        :options="tableFieldsArr">
                                                    </v-select>
                                                </td>
                                                <td v-else>
                                                    <v-select v-model="selected" name="data.value" placeholder="Select"
                                                        label="text"
                                                        :options="tableFieldsArr">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" v-model="data.default" id="default" placeholder="Default" name="default">
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td class="no-data-found" colspan="3">{{"No Data Found!"}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="batchProcess">
                                <p>&nbsp;</p>
                                <p class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNum}} is processing please wait!</p>
                            </div>
                            <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                            <div class="btn-groups">
                                <input type="submit" id="CreatePurchaseOrderBtn" value="Import" class="btn btn-primary" v-on:click.prevent="importReport">
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import VueSSE from 'vue-sse'
Vue.use(VueSSE);
let msgServer;
export default {
  name: "ContractCreate",

  mixins:[commonMixins,contractMixins],
  data: () => ({
    loading:false,
    permissions: [],
    cantAccessPage: "",
    spreadsheetFieldsArr: [],
    tableFieldsArr: [],
    sourcesArr: [],
    mkey: "",
    moduleId: "",
    module_error_msg: "",
    file_error_msg: "",
    error: "",
    data:{
        value:'',
    },
    selectedArr:[],
    selected:"",
    batchId:'',
    batchProcess:false,
    batchError:false,
    batchErrorMsg:""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_defect' ) {
                        self.cantAccessPage = true;

                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData();
  },
  beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
  methods: {
      checkBatchStatus:function(){
                var self =  this;

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess = false;
                            sse.close();

                            self.$swal('',data.message,'success');
                            self.$router.push("/import-data");
                        }else if (data.status == "2") {
                            self.batchProcess = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
      loadFieldData: function(){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            var formData = new FormData();
            if (segments[2]) {
                formData.append('module', segments[2]);
            }
            formData.append('fileName', localStorage.getItem('fileName'));

            self.loading = true;
            $('#myButton').text('Fetching...');
            $('#myButton').prop('disabled',true);
            $.ajax({
            url: process.env.ROOT_API + "/fetch_excel_fields",
            type: "POST",
            // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
            data: formData,
            headers: this.ajxHeaders,
            crossDomain: true,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (data) {
                $('#myButton').text('Import');
                $('#myButton').prop('disabled',false);
                self.loading = false;
                self.spreadsheetFieldsArr = data.content.table_fields;
                self.tableFieldsArr = data.excel;
                self.selectedArr = data.selectedArr;
                // localStorage.setItem('fileName',data.content);
                // self.$router.push('/import-data-content/'+self.moduleId.text);
            },
            error: function (jqXHR, exception) {
                $('#myButton').text('Import');
                $('#myButton').prop('disabled',false);
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                }
            }
        });
    },
getModules() {
    var self = this;
        self.loading = true;
        self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/get_modules_by_package",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.moduleArr = data;
                console.log(data);
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
    importReport(){
        var self = this;
        var formData = new FormData();

        var path = window.location.pathname;
            var segments = path.split("/");

            var formData = new FormData();
            if (segments[2]) {
                formData.append('module', segments[2]);
            }
        formData.append('fields', JSON.stringify(self.spreadsheetFieldsArr));
        formData.append('Excelfields', JSON.stringify(self.tableFieldsArr));
        formData.append('selectedfields', JSON.stringify(self.selectedArr));
        formData.append('fileName', localStorage.getItem('fileName'));
        self.loading=true;
        $.ajax({
            url: process.env.ROOT_API + "/import_data",
            type: "POST",
            headers: this.ajxHeaders,
            data:formData,
            crossDomain: true,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // self.moduleArr = data;
                if (segments[2] == 'Permission'){
                    self.batchProcess = true;
                    self.batchId = data.content;
                    self.checkBatchStatus();

                    return;
                }
                if(data.code == 200){
                    self.$swal('','Data Imported','success');
                    self.$router.push("/import-data");
                }
                if(data.code == 201){
                    self.$swal('','Excel Sheet Is Empty','info');
                }
                console.log(data);
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ImportDataContent.vue